export const STORE_CARD_PREFIX = "StoreCard";

export const STORE_CARD_CLASSES = {
  infoBox: `${STORE_CARD_PREFIX}-infoBox`,
  titleBox: `${STORE_CARD_PREFIX}-titleBox`,
  storeInfo: `${STORE_CARD_PREFIX}-storeInfo`,
  clickAndCollectTrialStoreTag: `${STORE_CARD_PREFIX}-clickAndCollectTrialStoreTag`,
  services: `${STORE_CARD_PREFIX}-services`,
};
